<template>
<v-card class="pa-2">
    <div class="detail font-weight-bold pa-0 ma-0">Personal details</div>
    <v-row no-gutters align="center" class="pt-2 im-search">
        <v-col cols="12" md="6" class="px-2">
            <v-text-field v-model="item.first_name" class="ma-0 pa-0" :rules="rules.name" label="First name" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-text-field v-model="item.last_name" class="ma-0 pa-0" label="Last name" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-text-field v-model="item.nickname" class="ma-0 pa-0" label="Nickname" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-select class="ma-0 pa-0" v-model="item.title" :items="title_items" item-text="text" item-value="value" :menu-props="{transition:'scale-transition', 'offset-y': ''}" label="Title" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-select class="ma-0 pa-0" v-model="item.gender" :items="gender_items" item-text="text" item-value="value" :menu-props="{transition:'scale-transition', 'offset-y': ''}" label="Gender" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="c_date" :value="`${item.birthdate.year}-${item.birthdate.month}-${item.birthdate.day}`" class="ma-0 pa-0" label="Birthday" readonly v-on="on" />
                </template>
                <v-date-picker ref="picker" v-model="date" :value="`${item.birthdate.year}-${item.birthdate.month}-${item.birthdate.day}`" :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" @change="closeMenu">
                    <v-spacer></v-spacer>
                    <v-btn text color="red" @click="date = null, menu= false">Clear date</v-btn>
                </v-date-picker>
            </v-menu>
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-text-field v-model="item.phone" class="ma-0" label="Phone" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-text-field v-model="item.website" class="ma-0" label="Website" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-select class="ma-0" v-model="item.timezone" :items="timezone" :menu-props="{transition:'scale-transition', 'offset-y': ''}" label="Timezone" />
        </v-col>
    </v-row>
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";

export default {
    props: {
        item: {
            type: Object,
            default: defaults.user_item
        },
    },
    components: {},
    data() {
        return {
            date: null,
            //props
            birthdate: null,
            service: {},
            valid: true,
            menu: false,

            rules: {
                name: [v => !!v || "User first name is required"],
                email: [
                    v => !!v || "E-mail is required",
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
                ],
            },
            title_items: [{
                    text: "Ms.",
                    value: "mr"
                },
                {
                    text: "Mrs.",
                    value: "mrs"
                },
                {
                    text: "Doctor",
                    value: "dr"
                }
            ],
            gender_items: [{
                    text: "Male",
                    value: "male"
                },
                {
                    text: "Female",
                    value: "female"
                }
            ],
            timezone: [
                "Europe/Amsterdam",
                "Europe/Athens",
                "Europe/Belgrade",
                "Europe/Berlin",
                "Europe/Bratislava",
                "Europe/Bucharest",
                "Europe/Budapest",
                "Europe/Chisinau",
                "Europe/Helsinki"
            ],
        };
    },

    computed: {
        c_date: {
            get() {
                if(!this.date) {

                    if(!this.item.birthdate.year || this.item.birthdate.month || this.item.birthdate.day) {
                        return 'N/A'
                    }

                    return this.$moment(`${this.item.birthdate.year}-${this.item.birthdate.month}-${this.item.birthdate.day}`)
                        .format('DD MMM YYYY');
                }

                return this.$moment(this.date)
                    .format('DD MMM YYYY');
            },
            set(val) {}
        },
    },

    watch: {
        date(val) {
            if(val) {
                this.item.birthdate.day = this.$moment(val)
                    .date();
                this.item.birthdate.month = this.$moment(val)
                    .month() + 1;
                this.item.birthdate.year = this.$moment(val)
                    .year();
            } else {
                this.item.birthdate.day = null;
                this.item.birthdate.month = null;
                this.item.birthdate.year = null;
            }
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        closeMenu() {
            this.menu = false;
        },

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format("DD MMM YY");
        },
    }
};
</script>
